export default "__VITE_ASSET__DfZwgXZx__"